import { useIsMobileDevice } from "@l2r-front/l2r-ui"

import * as Styled from "./TechniqueItemCard.styled"

export function TechniqueItemCardSkeleton(props) {

    const isMobile = useIsMobileDevice()

    return <Styled.Skeleton isMobile={isMobile} {...props} />
}